"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const _1 = require("../.");
const useControlLogic = (InputComponent, _a) => {
    var { name, label, initialValue, type, help, className, prefix, suffix, narrow, large, inlineLabel, inline, noBottomGutter, disabled } = _a, otherProps = __rest(_a, ["name", "label", "initialValue", "type", "help", "className", "prefix", "suffix", "narrow", "large", "inlineLabel", "inline", "noBottomGutter", "disabled"]);
    const fieldsData = react_1.default.useContext(_1.FieldsContext);
    const setValue = react_1.default.useContext(_1.SetValueContext);
    const fieldData = fieldsData[name] || {};
    const { value, touched, validation, mandatory, help: fieldsDataHelp, } = fieldData;
    react_1.default.useEffect(() => {
        // Appply default field value on init and when it changes.
        if (initialValue && !touched) {
            setValue(name, initialValue, mandatory);
        }
    }, [initialValue]);
    const inputProps = Object.assign(Object.assign({}, otherProps), { name, value: value !== null ? value : initialValue, mandatory,
        type,
        setValue,
        // Props below are typical for FormControl, but some design systems, like
        // MUI for example, sets them on an input level. Puting them there makes
        // this library more universal.
        label, validation: validation || '', help: fieldsDataHelp || help, disabled,
        prefix,
        suffix });
    const formControlProps = {
        name,
        inlineLabel,
        inline,
        narrow,
        large,
        noBottomGutter,
        validation: validation || '',
        disabled,
        displayName: InputComponent.displayName || '',
        label,
        help: fieldsDataHelp || help,
        prefix,
        suffix,
        className,
    };
    return {
        inputProps,
        formControlProps,
    };
};
exports.default = useControlLogic;
